import { useStoreCommon } from '@common/store/common';
import { useWindowResize, useWXFontSizeReset } from '@common/hooks';

/**
 * 页面基础初始化
 * 1. 初始化系统信息
 * 2. 初始化URL参数
 * 3. 动态宽度 - 屏幕适配， 窗口大小变化时重新计算
 */
export const usePageBaseInit = () => {
    useWXFontSizeReset();
    const storeCommon = useStoreCommon();
    storeCommon.initUrlParams();
    storeCommon.initSystemInfo();
    storeCommon.dynamicWidth();
    storeCommon.initInTopTab();
    useWindowResize(() => {
        storeCommon.dynamicWidth();
    });
};
